import React from 'react';
import { Icon } from 'semantic-ui-react';

const FixedIcon = ({style, minWidth = '25px', ...props}) =>
  <Icon style={{...style, minWidth}} {...props}/>;

export default FixedIcon;



// WEBPACK FOOTER //
// ./src/component/FixedIcon.js